// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1026":"126f616e8b82014a","6337":"126f616e8b82014a"}[chunkId] + ".css";
};